import * as React from 'react'

const SvgSettings = (props) => (
  <svg
    width={30}
    height={30}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      opacity={0.35}
      d='M20 23.66a3.095 3.095 0 0 1 2.67-.205 1.767 1.767 0 0 0 1.99-.537 12.46 12.46 0 0 0 2.026-3.507c.276-.734.015-1.54-.584-2.047a3.09 3.09 0 0 1-.001-4.73c.598-.508.86-1.313.583-2.048a12.445 12.445 0 0 0-2.026-3.506 1.767 1.767 0 0 0-1.99-.537 3.09 3.09 0 0 1-4.18-2.421 1.747 1.747 0 0 0-1.429-1.448 12.29 12.29 0 0 0-4.117 0 1.748 1.748 0 0 0-1.429 1.447 3.09 3.09 0 0 1-4.181 2.423 1.767 1.767 0 0 0-1.99.537 12.455 12.455 0 0 0-2.025 3.506c-.278.734-.015 1.54.583 2.047A3.09 3.09 0 0 1 5 15a3.09 3.09 0 0 1-1.1 2.366c-.598.508-.86 1.313-.583 2.048a12.447 12.447 0 0 0 2.026 3.506 1.767 1.767 0 0 0 1.99.537 3.09 3.09 0 0 1 4.18 2.421 1.747 1.747 0 0 0 1.429 1.448 12.285 12.285 0 0 0 4.117 0 1.744 1.744 0 0 0 1.429-1.447A3.09 3.09 0 0 1 20 23.66Z'
      fill='#101AA1'
    />
    <path d='M15 10a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z' fill='#101AA1' />
  </svg>
)

export default SvgSettings
